import { useQuery } from '@tanstack/react-query'
import { useTRPC } from '~/utils/trpc'
import type { LeakV0Window } from './chartWindow'

const SERIES_STALE_TIME_MS = 5 * 60_000

export const useLeakV0Series = (stationId: string, window: LeakV0Window) => {
  const trpc = useTRPC()

  return useQuery(
    // One retry rather than the default three: the procedure runs a 14-day bucket scan alongside a
    // Shayp fetch, so a failed attempt is expensive and its backoff chain hides the error.
    trpc.ops.stations.leakV0Series.queryOptions(
      { stationId, ...window },
      { staleTime: SERIES_STALE_TIME_MS, retry: 1, refetchOnWindowFocus: false }
    )
  )
}
